// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class User extends TrackingModel {
	public UserId: number = 0;
	public UID: string = "";
	public PasswordHash: string = "";
	public PasswordSalt: string = "";
	public IsDisabled: boolean = false;
	public IsLocked: boolean = false;
	public IsRequireChangePassword: boolean = false;
	public LoginFailedAttemptCount: number = 0;
}